var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_REMITTANCE_PAYOUT_CYCLE_REQUEST, updateRemittancePayoutCycleFailure, updateRemittancePayoutCycleSuccess } from "../../actions";
const onUpdateRemittancePayoutCycle = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        console.log("Fetching active plan data for tenantId:", action.payload.tenantId);
        try {
            APIIN.putCompany(`/company/admin/billing/remittance?tenantId=${action.payload.tenantId}`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* updateRemittancePayoutCycleWorker(action) {
    try {
        const data = yield call(onUpdateRemittancePayoutCycle, action);
        yield put(updateRemittancePayoutCycleSuccess(data));
    }
    catch (error) {
        yield put(updateRemittancePayoutCycleFailure(error));
    }
}
export function* watchUpdateRemittancePayoutCycle() {
    yield takeLatest(UPDATE_REMITTANCE_PAYOUT_CYCLE_REQUEST, updateRemittancePayoutCycleWorker);
}
